var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileNotificationsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.05 48.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clsw-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "clsw-1",
    d: "M40,36a1.89,1.89,0,1,0-3.72.7,1.89,1.89,0,0,1-1.51,2.21,2,2,0,0,1-.35,0H5.67a1.89,1.89,0,0,1-1.89-1.89,1.34,1.34,0,0,1,0-.35,19.29,19.29,0,0,1,2.65-6.57c1.26-2.21,2.57-4.5,2.57-8V19.29a11,11,0,0,1,10.81-11h.35A11,11,0,0,1,31,19.29v2.84a13.31,13.31,0,0,0,1.9,6.76,1.89,1.89,0,0,0,3.32-1.8,9.67,9.67,0,0,1-1.44-5V19.29A14.78,14.78,0,0,0,21.9,4.66V1.9a1.89,1.89,0,1,0-3.78,0h0V4.67A14.81,14.81,0,0,0,5.26,19.29v2.84c0,2.52-.92,4.12-2.07,6.14A23,23,0,0,0,.1,36a5.67,5.67,0,0,0,4.53,6.62,5.16,5.16,0,0,0,1,.1h8.7a5.68,5.68,0,0,0,11.35,0v0h8.66a5.67,5.67,0,0,0,5.67-5.67A6.2,6.2,0,0,0,40,36ZM20,44.63a1.89,1.89,0,0,1-1.89-1.89h3.78A1.89,1.89,0,0,1,20,44.63Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNotificationsWhite);
export default __webpack_public_path__ + "static/media/profile_notifications_white.9a9b85b06dce4cc35e9fe9d300487747.svg";
export { ForwardRef as ReactComponent };